import { render, staticRenderFns } from "./document-upload.vue?vue&type=template&id=6ca9fcff&"
import script from "./document-upload.vue?vue&type=script&lang=js&"
export * from "./document-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports